module.exports = __webpack_public_path__ + "static/media/crown.52cc8d6b.svg";